import contentDisposition from 'content-disposition'
import download from 'downloadjs'
import qs from 'qs'

import {fetch} from './sentry-fetch/browser'

// there are limits to next.js code-splitting, and it can't handle
// requiring some files on both api routes and frontend

export const fetchFile = async (
  url: string,
  query = {},
  init?: RequestInit,
  defaultFilename?: string,
): Promise<{blob: Blob; filename: string; mime: string}> => {
  const response = await fetch(`${url}${qs.stringify(query, {addQueryPrefix: true})}`, init)

  if (response.ok) {
    const dispositionHeader = response.headers.get('Content-Disposition') || ''
    const mime = response.headers.get('Content-Type') || ''
    const disposition = contentDisposition.parse(dispositionHeader)
    const filename = disposition?.parameters?.filename ?? defaultFilename ?? 'file'
    const blob = await response.blob()
    return {blob, filename, mime}
  } else {
    throw new Error(response.statusText)
  }
}

export const downloadFile = async (
  url: string,
  query = {},
  init?: RequestInit,
  defaultFilename?: string,
): Promise<XMLHttpRequest | boolean | null> => {
  try {
    const {blob, filename} = await fetchFile(url, query, init, defaultFilename)
    if (blob) {
      return download(blob, filename)
    }
    return null
  } catch (e) {
    throw new Error(e.message)
  }
}

// categories helpers

export type Subcategory = {name: string; code: string}

export type Category = {name: string; number: number; categories: Record<string, Subcategory>}

export type CategoriesMapped = Record<number, Category>
